import { Box, Button, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MobileMenuOverlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9998,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
}));

export const MobileMenuContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 56,
  left: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '304px',
  height: 'calc(100vh - 56px)',
  backgroundColor: theme.palette.common.white,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const MobileMenuContent = styled(Box)(({ theme }) => ({
  height: 'calc(100vh - 56px)',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(3, 2, 2),
}));

interface MobileMenuItemProps {
  active?: boolean;
  padding?: number;
}

export const MobileMenuItem = styled(Button)<MobileMenuItemProps>(
  ({ theme, active, padding = 1 }) => ({
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
    textTransform: 'none',
    backgroundColor: active ? theme.palette['mint-green'][50] : theme.palette.common.white,
    padding: theme.spacing(padding),
    borderRadius: theme.spacing(1),
    color: active ? theme.palette.primary.dark : theme.palette.text.primary,
  })
);

export const MobileMenuItemText = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const MobileMenuFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const MobileMenuFooterContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

interface SimpleButtonProps {
  active?: boolean;
}

export const SimpleButton = styled(MobileMenuItem)<SimpleButtonProps>(({ theme }) => ({
  padding: theme.spacing(0),
}));

export const ChangeLanguageButtonContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
}));

export const ChangeLanguageButton = styled(MenuItem)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 0.65),
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    minHeight: '32px',
    padding: 0,
  },
}));
